<template>
  <div
    v-if="vehicle_locking && vehicle_locking.time_until_unlocked"
    :key="vehicle_locking.id || '0'"
  >
    <VueCountdown
      :time="vehicle_locking.time_until_unlocked"
      class="countdown"
      :transform="transform"
      tag="p"
      @end="onCountdownEnded"
    >
      <template slot-scope="props">
        <div v-if="now() > vehicle_locking.extension_allowed_at_as_time && !expired">
          <a
            @click="onExtendCountdownClick"
            class="btn btn-primary"
          >{{ i18n.app.components.contract.extend }}</a>
        </div>

        <div>{{ props.minutes }}:{{ props.seconds }}</div>
      </template>
    </VueCountdown>

    <b-modal
      ref="modal-countdown-ended"
      hide-footer
      :title="i18n.app.components.contract.time_elapsed"
    >
      <div class="d-block text-center">
        <h3>{{i18n.messages.reservation_time_elapsed}}</h3>
      </div>
    </b-modal>
  </div>
</template>

<script>
import VueCountdown from "@chenfengyuan/vue-countdown";
import VehicleLockingService from "@/services/VehicleLockingService";

export default {
  props: ["vehicle"],
  name: "contract-countdown",
  components: {
    VueCountdown
  },
  data() {
    return {
      time: null,
      vehicle_locking: null,
      expired: false
    };
  },
  mounted() {
    this.vehicleLockingService = new VehicleLockingService(this.vehicle.id);
    this.initCountdown();
  },
  destroyed() {
    if (this.vehicle_locking) {
      this.vehicleLockingService.destroy(this.vehicle_locking.id);
    }
  },
  methods: {
    initCountdown() {
      this.vehicleLockingService.insert().then(vehicleLocking => {
        this.vehicle_locking = vehicleLocking;
      });
    },
    onCountdownEnded(ended) {
      this.expired = true;
      this.$router.go(-1);
    },
    transform(props) {
      Object.entries(props).forEach(([key, value]) => {
        const digits = value < 10 ? `0${value}` : value;
        props[key] = `${digits}`;
      });

      return props;
    },
    getCounterTime(until) {
      return until - this.now();
    },
    now() {
      return new Date().getTime();
    },
    onExtendCountdownClick() {
      this.vehicleLockingService
        .update(this.vehicle_locking)
        .then(vehicleLocking => {
          this.vehicle_locking = vehicleLocking;
        });
    },
    getVehicleLocking() {
      return this.vehicle_locking;
    }
  }
};
</script>
